<template>
    <div class="wrapper" :class="computedWrapperClass">
        <div v-if="isShowResultPage">
            <router-view></router-view>
        </div>

        <OneButtonModal
            :subTitleText="errorStateData?.errorMessage"
            buttonText="닫기"
            buttonTextColor="#1377C4"
            :isOpen="!!errorStateData"
            :onClick="handleClick"
        />
        <Toast
            :isOpen="!!toastStateData"
            :title="toastStateData?.title"
            :textColor="toastStateData?.textColor"
            @close="toastStore.clearToast"
        />
    </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import config from '@common/common/config';
import { historyPage, isWebviewView } from '@common/common/utils';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { useClusterInAppStore } from '@common/cluster-common';
import useErrorStore from '@common/common/stores/error';
import useToastStore from '@common/common/stores/toast';
import OneButtonModal from '@common/common/components/teleport/OneButtonModal.vue';
import Toast from '@common/common/components/teleport/Toast.vue';

const errorStore = useErrorStore();
const toastStore = useToastStore();
const clusterInAppStore = useClusterInAppStore();
// const router = useRouter();
const route = useRoute();
const { errorStateData } = storeToRefs(errorStore);
const { toastStateData } = storeToRefs(toastStore);
const { isReadyInAppWebView } = storeToRefs(clusterInAppStore);

const isShowResultPage = computed(() => {
    if (isWebviewView(route.name as string)) {
        return true;
    } else {
        if (route.query.isShared === 'true') {
            // 인앱 공유 페이지에서 온 경우
            return true;
        } else {
            if (route.query.shareToken && route.query.currentClusterID && route.query.previousClusterID) {
                return true;
            } else {
                return !isReadyInAppWebView.value ? false : true;
            }
        }
    }
});

const computedWrapperClass = computed(() => {
    if (route.name === 'in-app-trend-report') {
        return 'bg-white';
    } else {
        return '';
    }
});

const handleClick = () => {
    if (errorStateData.value?.errorType === 'GLOBAL_ERROR') {
        // 웹뷰인 경우 홈으로 이동 / 인앱인 경우 웹뷰 종료
        if (errorStateData.value?.errorAction === 'GO_MAIN') {
            historyPage(true);
        } else if (errorStateData.value?.errorAction === 'CLOSE_MODAL') {
            errorStore.clearError();
        }

        errorStore.clearError();
    } else {
        errorStore.clearError();
    }
};

onMounted(() => {
    const hostname = window.location.hostname;
    // 로컬 개발 환경 or 허용된 도메인인 경우 인앱 웹뷰 준비 완료 처리
    const isAllowedHostnameList = ['webview.test.inbody.dev', 'webview.beta.inbody.dev', 'webview.inbody.dev'];

    if (config.isLocalDevelopment || isAllowedHostnameList.includes(hostname)) {
        clusterInAppStore.isReadyInAppWebView = true;
    }
});
</script>

<style scoped lang="scss">
.text-area-wrap {
    width: 100%;
    height: 10rem;
    box-sizing: border-box;
    border: 1px solid #000;
}

.wrapper {
    background: $bg_gradation;
    height: 100%;
    overflow: auto;

    &.bg-white {
        background: $primary-white;
    }
}
</style>
